import * as React from 'react';
import { Box, TextField } from '@mui/material';
import { Controller, FieldErrors } from 'react-hook-form';
import { ItemCreatRequest, ItemListResponse } from 'types/product/product-item';

interface Props {
    errors: FieldErrors<ItemCreatRequest>;
    control: any;
    data?: ItemListResponse;
}

const ItemGoldGem: React.FC<Props> = ({ errors, control, data }) => {
    const defaultValue = data?.itemValue?.count ?? '';

    return (
        <Box>
            <Controller
                name="itemValue.count"
                control={control}
                defaultValue={defaultValue}
                rules={{
                    required: 'Price Title is required',
                    pattern: {
                        value: /^[0-9]*[.,]?[0-9]*$/,
                        message: 'Only numbers are allowed',
                    },
                }}
                render={({ field: { name, value, onChange } }) => (
                    <TextField
                        fullWidth
                        name={name}
                        value={value ?? ''}
                        onChange={(e) => {
                            const val = e.target.value.replace(',', '.');
                            if (/^[0-9]*\.?[0-9]*$/.test(val)) {
                                onChange(val);
                            }
                        }}
                        label="Value"
                        error={!!errors?.itemValue?.count}
                        helperText={errors?.itemValue?.count?.message}
                        slotProps={{
                            input: {
                                inputMode: 'decimal',
                            },
                        }}
                    />
                )}
            />
        </Box>
    );
};

export default ItemGoldGem;
